import React, { useCallback, useEffect } from "react";
import AddressBookSuggestion from "src/components/AddressBookSuggestion";
import { ChainSingleSelection } from "src/components/ChainSelection";
import { useChains } from "src/components/FetchConfig";
import MpTextField from "src/components/MpTextField";
import { Checkbox } from "src/components/MuiGenerals";
import { useTranslation } from "src/hooks";
import {
  AddressBookFilterType,
  createAddressBookFilterConfig,
} from "src/utils/AddressBookFilter/createAddressBookFilter";
import { AddressBookOrder } from "src/views/AssetManagement/Swap/types";

import EnumWalletTypes from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";

import { CreateRequestDialogFields } from "../";
import ChainNameSingleSelection from "../../TronWalletResourceBalance/components/ChainNameSingleSelection";
import LayoutRow from "../../TronWalletResourceBalance/components/LayoutRow";
import { createWalletNameWithPrefix } from "../helpers/createWalletNameWithPrefix";
import WalletVersionSingleSelectionCommon from "src/components/Common/WalletVersionSelection/WalletVersionSingleSelection";
import {
  MerchantChainConfigStatus,
  WalletSmartAccountType,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import WalletVersionSingleSelection from "./components/WalletVersionSingleSelection";

interface IProps {
  fields: CreateRequestDialogFields;
  setFields: React.Dispatch<React.SetStateAction<CreateRequestDialogFields>>;
}

const CreateRequestDialogContent = (props: IProps) => {
  const { fields, setFields } = props;
  const { t, translate, tc } = useTranslation("walletDeploymentRequests");

  const TITLE_MIN_WIDTH = "180px";

  const updateWalletAddress = useCallback(
    (name: keyof AddressBookOrder, value: string) => {
      if (name === "to_address" || name === "rawItem") {
        return setFields((prevFields: any) => ({
          ...prevFields,
          ...(name === "to_address" && {
            ownerAddress: value,
            addressBookOrder: {
              ...prevFields.addressBookOrder,
              [name]: value,
            },
            ...(value === "" ? { ownerAddress: "", rawWalletInfo: null } : {}),
          }),
          ...(name === "rawItem" && {
            rawWalletInfo: value,
          }),
        }));
      }
    },
    [setFields],
  );

  const onChainChange = (chain_name: string) =>
    setFields((f: any) => ({
      ...f,
      chainName: chain_name,
      addressBookOrder: {
        to_address: "",
        amount: "",
        to_wallet_tag: "",
        wallet_type: "",
        display_name: "",
      } as AddressBookOrder,
      ownerAddress: "",
      isSmartAccount: false,
      rawWalletInfo: null,
      contractVersion: "",
    }));

  // useEffect(() => {
  //   if (!fields.chainName) {
  //     setFields({
  //       ...fields,
  //       chainName: DEFAULT_CHAIN_NAME,
  //     });
  //   }
  // }, []);
  const { selectChainByPieces } = useChains();

  const { chain_type, chain_id } = selectChainByPieces({
    chain_name: fields.chainName,
  });

  const EOAConfig = createAddressBookFilterConfig(
    AddressBookFilterType.EOAHotWallet,
    { t: translate },
  );

  return (
    <div>
      <LayoutRow
        title={t("chainName")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          <ChainSingleSelection
            label={t("phChain_name")}
            setChoice={onChainChange}
            choice={fields.chainName}
            isDisabledUnselect={true}
            onlyEthAndTron
          />
        }
      />
      {/* <LayoutRow
        title={t("contractVersion")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          <WalletVersionSingleSelectionCommon
            value={String(fields.contractVersion || "")}
            onChange={(contractVersion) =>
              setFields((prev) => ({ ...prev, contractVersion }))
            }
            chainType={chain_type}
            chainId={Number(chain_id)}
            smartAccountType={WalletSmartAccountType.MultisignWallet}
            walletEnableStatus={MerchantChainConfigStatus.Enabled}
            disableCleanValueEffect={true}
            customLabel={tc("phSelection", { fieldName: t("contractVersion") })}
          />
        }
      /> */}
      <LayoutRow
        title={t("contract_wallet_version")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          <WalletVersionSingleSelection
            value={String(fields.contractVersion || "")}
            onChange={(contractVersion) =>
              setFields((prev) => ({ ...prev, contractVersion }))
            }
            chainType={chain_type}
            chainId={Number(chain_id)}
          />
        }
      />

      <LayoutRow
        title={t("owner_address")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          <AddressBookSuggestion
            item={fields.addressBookOrder as AddressBookOrder}
            isAllowFreeInput={false}
            isDisabled={false}
            walletTypes={[String(EnumWalletTypes.HotWallet)]}
            filterConfigs={[EOAConfig]}
            chain_name={fields.chainName || ""}
            setField={updateWalletAddress}
            config={{
              placeHolder: t("plzEnterAddress"),
            }}
          />
        }
      />
      <LayoutRow
        title={t("owner_wallet_name")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          <div style={{ margin: "8px 0" }}>
            {fields.rawWalletInfo?.wallet_name || "-"}
          </div>
        }
      />

      <LayoutRow
        title={t("contract_wallet_name")}
        titleStyle={{ minWidth: TITLE_MIN_WIDTH }}
        content={
          // <MpTextField
          //   label={t("wallet_name")}
          //   fullWidth={true}
          //   value={fields.walletName}
          //   onChange={(e) => {
          //     setFields((prev) => ({ ...prev, walletName: e.target.value }));
          //   }}
          // />
          <div style={{ margin: "8px 0" }}>
            {createWalletNameWithPrefix(
              fields.rawWalletInfo?.wallet_name || "",
            ) ?? "-"}
          </div>
        }
      ></LayoutRow>

      <LayoutRow
        title={t("auto_resource_rent")}
        isHide={chain_type !== 3}
        titleStyle={{ minWidth: "165px" }}
        content={
          <Checkbox
            checked={fields.isSmartAccount ? true : false}
            onChange={(e) =>
              setFields({
                ...fields,
                isSmartAccount: e.target.checked,
              })
            }
          />
        }
      />
    </div>
  );
};

export default CreateRequestDialogContent;
